import { useAuthStore } from '../store/auth.store';
import type { User } from '../types';

export function useAuth() {
  const user = useAuthStore((state) => state.user);
  const token = useAuthStore((state) => state.token);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);
  const actions = useAuthStore((state) => state.actions);

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    login: actions.login,
    logout: actions.logout,
    updateUser: actions.updateUser,
    setLoading: actions.setLoading,
  };
}

export function useCurrentUser(): User | null {
  return useAuthStore((state) => state.user);
}
